import { render, staticRenderFns } from "./table-anexos.vue?vue&type=template&id=ddfbd544&scoped=true&"
import script from "./table-anexos.vue?vue&type=script&lang=js&"
export * from "./table-anexos.vue?vue&type=script&lang=js&"
import style0 from "./table-anexos.vue?vue&type=style&index=0&id=ddfbd544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfbd544",
  null
  
)

export default component.exports